module.exports = __webpack_public_path__ + "media/images/refresh-1a3bea023cb373b37d130734a7dc76c4.png";